import { XHRBackend, RequestOptions } from '@angular/http';

import { AuthHttpService } from './auth-http.service';
import { AuthHttpConfig } from './auth-http-config';
import { LocalStorageProvider } from 'app/shared';

export function authHttpFactory(connectionBackend: XHRBackend, options: RequestOptions) {
  let config: AuthHttpConfig = new AuthHttpConfig('token', new LocalStorageProvider());

  return new AuthHttpService(config, connectionBackend, options);
}



// WEBPACK FOOTER //
// /dist/src/app/security/authorization/auth-http-factory.function.ts